import { render, staticRenderFns } from "./ErpDlsOrderSend.vue?vue&type=template&id=35f7ec1c&scoped=true&"
import script from "./ErpDlsOrderSend.vue?vue&type=script&lang=js&"
export * from "./ErpDlsOrderSend.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsOrderSend.vue?vue&type=style&index=0&id=35f7ec1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f7ec1c",
  null
  
)

export default component.exports